<div *ngIf="minText || maxText" class="label-container">
  <label>{{minText}}</label>
  <label>{{maxText}}</label>
</div>
<progress [max]="max" [value]="value"></progress>
